const SEARCH_TYPES = {
  SEARCH_BEGIN: "SEARCH_BEGIN",
  SEARCH_SUCCESS: "SEARCH_SUCCESS",
  SEARCH_FAILURE: "SEARCH_FAILURE",
};

export default SEARCH_TYPES;
